import { getRuntimeConfig } from '@retail/funnel-components';

// @ts-ignore
// eslint-disable-next-line no-undef
__webpack_public_path__ = getRuntimeConfig('ASSETS_PUBLIC_PATH');
